import { Vue } from 'vue-property-decorator';

import MainStorage from '@/storage/main';

import { randomAlphaNumeric } from '@/helpers/core';

const TEMP_ID_LENGTH = 16;

export type IdentityUser = {
  id: string | null;
};

export default class IdentityService {
  private static readonly user: IdentityUser = Vue.observable({
    id: null,
  });

  static initIdentity(): void {
    const id = MainStorage.getTempId() || this._generateTempId();

    this._setId(id);
  }

  static getTempUser(): IdentityUser {
    return this.user;
  }

  static getTempUserId(): string | null {
    return this.user.id;
  }

  static updateTempId(id: string): void {
    if (id.length !== TEMP_ID_LENGTH) {
      throw new TypeError('Incorrect temp id format');
    }

    this._setId(id);
  }

  static refreshIdentity(): void {
    const id = this._generateTempId();

    this._setId(id);
  }

  private static _generateTempId(): string {
    return randomAlphaNumeric(TEMP_ID_LENGTH);
  }

  private static _setId(id: string): void {
    Object.assign(this.user, { id });

    MainStorage.saveTempId(id);
  }
}
